// extracted by mini-css-extract-plugin
export default {"grid-alike-section":"BoxSection_grid-alike-section__xKkbX","grid-header-right":"BoxSection_grid-header-right__7lN4S"};